<template>
  <div>
    <div class="centered-header">
      <h4 class="ui header" style="color: #092442;">
        <i class="clipboard outline icon"></i>
        <div class="content">
          Follow Up
        </div>
      </h4>
    </div>
    <div class="ui divider"></div>
    <div v-if="currentFollowUp && currentFollowUp.result">
      <div
        class="ui raised tall stacked segment"
        style="white-space: pre-line;"
      >
      <div class="ui centered header">
        {{ currentFollowUp.name }}
      </div>
        {{ currentFollowUp.result }}
      </div>
    </div>

    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No Follow up has been added
        </div>
        <div
          class="ui primary button"
          style="background-color: #092442"
          @click="showModal()"
          v-if="canAdd"
        >
          Add Follow up
        </div>
      </div>
    </div>

    <div
      class="ui large longer modal"
      :id="'follow-up-' + reservationVisitId"
      style="margin-top: 20px !important;"
    >
      <div class="header">Add Follow up</div>

      <div class="content">
        <div class="ui form">
          <div class="required field">
            <label>Follow Up Name</label>
            <input
              type="text"
              placeholder="Follow Up Name"
              v-model="currentFollowUp.name"
            />
          </div>
          <div class="reqired field">
            <label>Follow Up Result</label>
            <textarea
              placeholder="Follow Up Result"
              v-model="currentFollowUp.result"
            />
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui button" @click="hideModal()">
          {{ $t('discard') }}
        </div>

        <div
          class="ui blue button"
          style="background-color: #092442"
          @click="save()"
        >
          {{ $t('save') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reservationVisitId: { type: Number, default: null },
    followup: { type: Object, default: () => {} },
    canAdd: { type: Boolean, default: false }
  },
  data() {
    return {
      currentFollowUp: {
        name: null,
        result: null
      }
    };
  },
  mounted() {
    if (this.followup && this.followup.name) {
      this.currentFollowUp = window._.cloneDeep(this.followup)
    }
  },
  methods: {
    showModal() {
      $('#follow-up-' + this.reservationVisitId).modal('show');
    },
    hideModal() {
      $('#follow-up-' + this.reservationVisitId).modal('hide');
    },
    save() {
      this.$http
        .post(`reservation_visits/${this.reservationVisitId}/add/follow-up`, {
          follow_up: this.currentFollowUp,
          clinic_id: this.getClinicId()
        })
        .then(response => {
          this.currentFollowUp = {
            name: response.data.name,
            result: response.data.result
          };
          this.hideModal();
        });
    }
  }
};
</script>

<style scoped>
.centered-header {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/visits/visit_components/FollowUpPart.vue